import React from "react";

//Line icons used in the header, footer and contact page
const PATHS = {
  phone: "M8.6 3.5 6.3 3a1.3 1.3 0 0 0-1.4.8L3.6 7c-.2.4-.1 1 .2 1.3a22 22 0 0 0 11.9 11.9c.4.3.9.4 1.3.2l3.2-1.3a1.3 1.3 0 0 0 .8-1.4l-.5-2.3a1.3 1.3 0 0 0-1-1l-3.2-.8a1.3 1.3 0 0 0-1.2.3l-1 1a15 15 0 0 1-5.6-5.6l1-1c.3-.3.4-.8.3-1.2l-.8-3.2a1.3 1.3 0 0 0-1-1z",
  mail: "M3 5.5h18v13H3z M3 6l9 7 9-7",
  pin: "M12 21s-7-6.3-7-11.5a7 7 0 0 1 14 0C19 14.7 12 21 12 21z M12 12.2a2.7 2.7 0 1 0 0-5.4 2.7 2.7 0 0 0 0 5.4z",
  lock: "M12 3 4.5 6v5.5c0 4.6 3.2 8.6 7.5 9.5 4.3-.9 7.5-4.9 7.5-9.5V6z M9.3 11.3h5.4v4.4H9.3z M10.3 11.3V9.8a1.7 1.7 0 0 1 3.4 0v1.5",
};

export const LineIcon = ({ name }) => (
  <svg
    className={"line-icon"}
    viewBox={"0 0 24 24"}
    aria-hidden={"true"}
    focusable={"false"}
  >
    <path d={PATHS[name]} />
  </svg>
);

//Filled brand icons (WhatsApp, Facebook, Instagram)
const BRANDS = {
  whatsapp: "M12 2.2A9.8 9.8 0 0 0 3.6 17l-1.3 4.8 4.9-1.3A9.8 9.8 0 1 0 12 2.2zm0 17.9a8.1 8.1 0 0 1-4.1-1.1l-.3-.2-2.9.8.8-2.8-.2-.3A8.1 8.1 0 1 1 12 20.1zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1l-.8 1c-.1.2-.3.2-.5.1a6.6 6.6 0 0 1-3.3-2.9c-.2-.4.2-.4.7-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-.9 2.2 5.2 5.2 0 0 0 1.1 2.7 11.8 11.8 0 0 0 4.5 4c1.7.7 2.3.8 3.2.6.5-.1 1.5-.6 1.7-1.2.2-.6.2-1.1.2-1.2-.1-.1-.2-.2-.5-.3z",
  facebook: "M13.4 21v-8h2.7l.4-3.1h-3.1V7.9c0-.9.3-1.5 1.6-1.5h1.6V3.6a22 22 0 0 0-2.4-.1c-2.4 0-4 1.4-4 4.1v2.3H7.5V13h2.7v8z",
  instagram: "M12 3.6c2.7 0 3 0 4.1.1 2.7.1 4 1.4 4.1 4.1.1 1.1.1 1.4.1 4.1s0 3-.1 4.1c-.1 2.7-1.4 4-4.1 4.1-1.1.1-1.4.1-4.1.1s-3 0-4.1-.1c-2.7-.1-4-1.4-4.1-4.1-.1-1.1-.1-1.4-.1-4.1s0-3 .1-4.1c.1-2.7 1.4-4 4.1-4.1 1.1-.1 1.4-.1 4.1-.1zM12 2c-2.7 0-3.1 0-4.1.1C4.2 2.2 2.2 4.2 2.1 7.9 2 8.9 2 9.3 2 12s0 3.1.1 4.1c.1 3.7 2.1 5.7 5.8 5.8 1 .1 1.4.1 4.1.1s3.1 0 4.1-.1c3.7-.1 5.7-2.1 5.8-5.8.1-1 .1-1.4.1-4.1s0-3.1-.1-4.1c-.1-3.7-2.1-5.7-5.8-5.8C15.1 2 14.7 2 12 2zm0 4.9a5.1 5.1 0 1 0 0 10.2 5.1 5.1 0 0 0 0-10.2zm0 8.5a3.4 3.4 0 1 1 0-6.8 3.4 3.4 0 0 1 0 6.8zm5.3-9.9a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4z",
};

export const BrandIcon = ({ name }) => (
  <svg
    className={"brand-icon"}
    viewBox={"0 0 24 24"}
    aria-hidden={"true"}
    focusable={"false"}
  >
    <path d={BRANDS[name]} />
  </svg>
);
